export default __webpack_public_path__ + "static/media/icon-kdb@3x.e3a2147f.png";